import React from 'react';
import { Link } from 'react-router-dom';

export default function Logo({ className = '', linkTo = '/', size = 'md' }) {
  const sizeClasses = {
    sm: 'h-16',      // 64px - doppio rispetto a prima (era 40px)
    md: 'h-24',      // 96px - quasi doppio rispetto a prima (era 56px)
    lg: 'h-32',      // 128px - doppio rispetto a prima (era 80px)
    xl: 'h-40'       // 160px - doppio rispetto a prima (era 96px)
  };

  const imgClass = `${sizeClasses[size]} w-auto ${className}`;

  const logoImg = (
    <img 
      src="/zonepass-logo-final.png" 
      alt="ZonePass Logo" 
      className={imgClass}
    />
  );

  if (linkTo) {
    return (
      <Link to={linkTo} className="flex items-center">
        {logoImg}
      </Link>
    );
  }

  return logoImg;
}
